import * as React from 'react';
import { SVGProps } from 'react';

const IconTeamSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM4 7c2.333 0 3 1.177 3 3H1c0-1.823.667-3 3-3zm3-3c0 .527-.136 1.022-.375 1.453a2 2 0 1 0 0-2.906C6.865 2.977 7 3.473 7 4zm4 6H8c0-.999-.176-2.048-.873-2.843a3.004 3.004 0 0 0-.072-.079C7.335 7.027 7.648 7 8 7c2.333 0 3 1.177 3 3z" />
  </svg>
);
export default IconTeamSizeXs;
